module.exports = __webpack_public_path__ + "static/media/green-drop.a878ac42.svg";